var map = {
	"./game_1_l.png": 406,
	"./game_1_m.png": 411,
	"./game_1_r.png": 416,
	"./game_2_l.png": 407,
	"./game_2_m.png": 412,
	"./game_2_r.png": 417,
	"./game_3_l.png": 408,
	"./game_3_m.png": 413,
	"./game_3_r.png": 418,
	"./game_4_l.png": 409,
	"./game_4_m.png": 414,
	"./game_4_r.png": 419,
	"./game_5_l.png": 410,
	"./game_5_m.png": 415,
	"./game_5_r.png": 420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 885;